import React, {useEffect, useState} from 'react'
import {Avatar, Badge, Button, Divider, List, Popover, Row, Skeleton, Space, Tabs} from "antd";
import {BellOutlined, CheckOutlined} from "@ant-design/icons";
import {getNotifications, getUserNotifications, patchNotification, patchUserNotification} from "../api/notifications";
import HttpError from "./base/HttpError";
import axios from "axios";
import "../asset/less/NotificationCenter.css"

export default (props) => {

    const CancelToken = axios.CancelToken.source()
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [all, setAll] = useState([])
    const [unreads, setUnreads] = useState([])
    const [archives, setArchives] = useState([])
    const [showUnreadsOnly, setShowUnreadsOnly] = useState(false)
    const colors = ["#FF5733", "#DAF7A6", "#C70039", "#900C3F", "#581845"];
    const [page, setPage] = useState(1)
    const pageSize = 12

    function compare( a, b ) {
      if ( new Date(a.updated_at) < new Date(b.updated_at) ){
        return -1;
      }
      if ( new Date(a.updated_at) > new Date(b.updated_at) ){
        return 1;
      }
      return 0;
    }

    useEffect(() => {
        setLoading(true)
        getUserNotifications(props.userId, 1, 12, CancelToken)
            .then((response) => {
                let allArray = []
                let unreadArray = []
                let archivesArray = []
                response.data.results.forEach((res)=>{
                    if (res.is_archive) {
                        archivesArray.push(res)
                    }else{
                        allArray.push(res)
                        if (!res.is_read) {
                            unreadArray.push(res)
                        }
                    }
                })
                setAll(allArray)
                setUnreads(unreadArray)
                setArchives(archivesArray)
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    return
                }
                // HttpError(error)
            }).finally(() => {
            setLoading(false)
        })

        return () => {
            if (loading)
                CancelToken.cancel("cancel")
        }
    }, [])

    const markAsRead = (index) => {

    }

    const archive = (item) => {
        const isArchive = !item.is_archive
        patchUserNotification(item.id, {is_archive: isArchive}).then(r => {
            item.is_archive = isArchive

            let newArray = archives
            if (isArchive) {
                newArray.push(item)
            }else{
                newArray = newArray.filter((archive)=>{return item.id !== archive.id})
            }
            newArray.sort(compare)
            setArchives(newArray)

            if (!isArchive && !item.is_read) {
                let newArray = unreads
                newArray.push(item)
                newArray.sort(compare)
                setUnreads(newArray)
            }
            if (!isArchive) {
                let newArray = all
                newArray.push(item)
                newArray.sort(compare)
                setAll(newArray)
            }
        }).catch((e)=>{
            console.log(e)
        })
    }

    const markAllAsRead = () => {
        const patchReqs = []
        unreads.forEach((unread)=>{
            patchReqs.push(patchUserNotification(unread.id, {is_read: true}))
        })
        Promise.all(patchReqs)
            .then(() => {
                let newAll = []
                all.forEach((item)=>{
                    item.is_read = true
                    newAll.push(all)
                })
                setAll(all)
                setUnreads([])
            })
            .catch((error) => {
                HttpError(error)
            })
    }

    const toggleUnreadRead = () => {
        setShowUnreadsOnly(!showUnreadsOnly)
    }

    const onLoadMore = () => {

    }

    const getNotificationList = (list) => {
        const loadMore =
            !loading && !loadingMore ? (
                <div
                    style={{
                        textAlign: 'center',
                        float: 'bottom',
                        marginTop: '100%',
                        height: 32,
                        lineHeight: '32px',
                        marginBottom: 12
                    }}
                >
                    <Button onClick={onLoadMore}>loading more</Button>
                </div>
            ) : null;

        return (
            <List
                className="demo-loadmore-list"
                loading={loading}
                itemLayout="horizontal"
                loadMore={loadMore}
                dataSource={list}
                style={{
                    width: '500px',
                    maxWidth: '100%',
                    minHeight: '180px',
                    maxHeight: '300px',
                    overflowY: 'scroll',
                    paddingTop: 0
                }}
                renderItem={(item) => (
                    <List.Item
                        style={{backgroundColor: item.is_read ? null: '#eaf7ff', paddingLeft: 24, paddingRight: 24,
                         cursor: 'pointer'}}
                        actions={[<a onClick={()=>{archive(item)}} key="list-loadmore-edit">{item.is_archive ? "Unarchive": "Archive"}</a>]}
                    >
                        <Skeleton avatar title={false} loading={item.loading} active>
                            <List.Item.Meta
                                avatar={<Avatar size={'large'} src={item.picture} style={{marginTop: '40%'}}/>}
                                title={<a style={{fontWeight: 'bold', fontSize: 14, color: 'black', marginTop: 8}} href="https://ant.design">{item.title}</a>}
                                description={<Space direction={'vertical'} style={{marginTop: 4}}>
                                    <a style={{fontSize: 14, fontWeight: 'bold', color: 'primary', marginTop: 4}}>View</a>
                                    <p style={{fontSize: 12, color: 'grey', padding: 0, marginTop: 4}}>{item.updated_at}</p>
                                </Space>}
                            />
                        </Skeleton>
                    </List.Item>
                )}
            />
        )
    }

    const displayNotificationList = () => {
        if (showUnreadsOnly) {
            return (
                <div
                    style={{
                        width: '500px',
                        height: '300px',
                        overflowY: 'scroll',
                        padding: '25px'
                    }}
                >
                    {unreads.map((notif, index) => {
                        const hyperlink = '//' + notif.hyperlink
                        //console.log(hyperlink);
                        return (
                            <div className='notification' key={index}>
                                <a onClick={() => markAsRead(index)}>
                                    <h4 style={{display: 'inline-block'}}>
                                        {'\u2B24'} <b>Sent: {notif.date}</b>
                                    </h4>
                                    <h5>
                                        <b>{notif.title}</b>
                                    </h5>
                                </a>
                                <p>
                                    {notif.message}{' '}
                                    {hyperlink != null && hyperlink !== '//null' && (
                                        <a href={hyperlink} target='_blank' rel='noreferrer'>
                                            Click
                                        </a>
                                    )}
                                </p>
                                <Divider/>
                            </div>
                        )
                    })}
                </div>
            )
        } else {
            //show reads
            return (
                <div
                    style={{
                        width: '500px',
                        maxWidth: '80vw',
                        height: '500px',
                        maxHeight: '80vh',
                        overflowY: 'scroll',
                        padding: '25px'
                    }}
                >
                    {reads.map((notif, index) => {
                        return (
                            <div className='notification' key={index}>
                                <h4>Sent: {notif.date}</h4>
                                <h5>{notif.title}</h5>
                                <p>{notif.message}</p>
                                <Divider/>
                            </div>
                        )
                    })}
                </div>
            )
        }
    }

    const displayNotificationCenter = () => {
        const items = [
            {
                key: '1',
                label: <>All <Badge count={all.length} showZero color="#000000"/></>,
                children: getNotificationList(all),
            },
            {
                key: '2',
                label: <>Unread <Badge count={unreads.length} showZero color="#000000"/></>,
                children: getNotificationList(unreads),
            },
            {
                key: '3',
                label: <>Archive <Badge count={archives.length} showZero color="#000000"/></>,
                children: getNotificationList(archives),
            }
        ]

        const onChange = (key) => {
            console.log(key);
        };

        return (
            <div>
                {loading && (
                    <Row style={{padding: 24}}>
                        <Skeleton active/>
                        <Skeleton active/>
                        <Skeleton active/>
                    </Row>
                )}
                {!loading && (
                    <Tabs style={{marginLeft: 4, paddingTop: 2}} defaultActiveKey="1" items={items}
                          onChange={onChange}/>
                )}
            </div>
        )
    }

    return (
        <Badge count={unreads.length} style={{display: 'block', marginRight: 0, paddingTop: 3}} color={'primary'}>
            <Popover
                overlayStyle={{
                maxWidth: "98vw"
              }}
                placement='bottomRight'
                title={
                    <Row style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <h3 style={{fontSize: 24, fontWeight: "bold", paddingTop: 24}}>
                            Notifications
                        </h3>
                        <Button icon={<CheckOutlined/>} type={'link'}
                                onClick={markAllAsRead} style={{
                            color: 'black', display: 'block', marginTop: 12, marginRight: 1,
                            textDecoration: 'underline'
                        }}>
                            Mark all as read
                        </Button>
                    </Row>
                }
                content={displayNotificationCenter}
                trigger='click'
            >
                <Button icon={<BellOutlined/>} style={{}}/>
            </Popover>
        </Badge>
    )
}